/* import __COLOCATED_TEMPLATE__ from './fin-resolution-understanding-modal.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { task } from 'ember-concurrency-decorators';
import type QuoteService from 'embercom/services/quote-service';
import { DEFAULT_REQUEST_PARAMS } from 'embercom/services/quote-service';
import { taskFor } from 'ember-concurrency-ts';
import { tracked } from '@glimmer/tracking';

interface Args {
  isOpen: boolean;
  onModalClose: (object: string) => void;
  finIncentiveExpiryDate: string;
}

export default class FinResolutionUnderstandingModal extends Component<Args> {
  @service declare appService: AppService;
  @service declare intercomEventService: $TSFixMe;
  @service declare quoteService: QuoteService;
  @service declare customerService: $TSFixMe;
  @tracked finIncentiveExpiryDate = '';

  constructor(owner: unknown, args: Args) {
    super(owner, args);
    this.trackAnalyticsEvent({
      action: 'viewed',
      object: 'fin_resolution_understanding_modal',
      place: 'fin_resolution_understanding_modal',
    });
    this.finIncentiveExpiryDate = this.args.finIncentiveExpiryDate;
    taskFor(this.loadQuotes).perform();
  }

  @task({ drop: true })
  *loadQuotes() {
    yield taskFor(this.quoteService.getQuotes).perform([
      {
        ...DEFAULT_REQUEST_PARAMS,
        planIds: [this.activeCorePlanId],
        source: 'fin-resolution-understanding-modal',
      },
    ]);
  }

  get hasExpirationDate() {
    return this.finIncentiveExpiryDate && this.finIncentiveExpiryDate !== '';
  }

  get isLoading() {
    return taskFor(this.loadQuotes).isRunning || this.quoteService.loading;
  }

  get activeCorePlanId() {
    return this.customerService.activePricing5CorePlanId;
  }

  get finResolutionsPrice() {
    let quote = this.quoteService.customerSubscriptionPrice;
    return quote?.finMetricPrice(this.activeCorePlanId);
  }

  private trackAnalyticsEvent(eventData: Record<string, string>) {
    this.intercomEventService.trackAnalyticsEvent(eventData);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'IncentiveOffer::FinResolutionUnderstandingModal': typeof FinResolutionUnderstandingModal;
    'incentive-offer/fin-resolution-understanding-modal': typeof FinResolutionUnderstandingModal;
  }
}
